const ShowLoaderPath: string[] = [
  '/cities',
  '/reviews',
  '/giftcards',
  '/browse-hotels',
  '/hotels/',
];

export default ShowLoaderPath;
